import { Asset, AssetType } from "../../models/assets/asset";
import { Media } from "../../models/assets/media";
import { EntityType, mediaService } from "../../services/media-service";
import { Extension } from "../../constants/extension";

const CHOSEN_SPORTS_DAY_GALLERY_EN: Asset[] = [
  {
    id: 1,
    name: "Team Celebration",
    url: mediaService.getMediaUrl(EntityType.EVENT, "chosen-sports-day", AssetType.IMAGE, Extension.PNG, 1),
    type: AssetType.IMAGE
  },
  {
    id: 2,
    name: "Prayer Huddle",
    url: mediaService.getMediaUrl(EntityType.EVENT, "chosen-sports-day", AssetType.IMAGE, Extension.PNG, 2),
    type: AssetType.IMAGE
  }
];

const CHOSEN_SPORTS_DAY_GALLERY_AR: Asset[] = [
  {
    id: 1,
    name: "احتفال الفرق",
    url: mediaService.getMediaUrl(EntityType.EVENT, "chosen-sports-day", AssetType.IMAGE, Extension.PNG, 1),
    type: AssetType.IMAGE
  },
  {
    id: 2,
    name: "حلقة صلاة",
    url: mediaService.getMediaUrl(EntityType.EVENT, "chosen-sports-day", AssetType.IMAGE, Extension.PNG, 2),
    type: AssetType.IMAGE
  }
];

const CHOSEN_WINTER_CONFERENCE_GALLERY_EN: Asset[] = [
  {
    id: 3,
    name: "Winter Conference Worship",
    url: mediaService.getMediaUrl(EntityType.EVENT, "chosen-winter-conference", AssetType.IMAGE, Extension.PNG, 1),
    type: AssetType.IMAGE
  },
  {
    id: 4,
    name: "Winter Conference Ministry",
    url: mediaService.getMediaUrl(EntityType.EVENT, "chosen-winter-conference", AssetType.IMAGE, Extension.PNG, 2),
    type: AssetType.IMAGE
  }
];

const CHOSEN_WINTER_CONFERENCE_GALLERY_AR: Asset[] = [
  {
    id: 3,
    name: "عبادة مؤتمر الشتاء",
    url: mediaService.getMediaUrl(EntityType.EVENT, "chosen-winter-conference", AssetType.IMAGE, Extension.PNG, 1),
    type: AssetType.IMAGE
  },
  {
    id: 4,
    name: "خدمة مؤتمر الشتاء",
    url: mediaService.getMediaUrl(EntityType.EVENT, "chosen-winter-conference", AssetType.IMAGE, Extension.PNG, 2),
    type: AssetType.IMAGE
  }
];

const CHOSEN_SUMMER_CONFERENCE_GALLERY_EN: Asset[] = [
  {
    id: 5,
    name: "Summer Conference Outpouring",
    url: mediaService.getMediaUrl(EntityType.EVENT, "chosen-summer-conference", AssetType.IMAGE, Extension.PNG, 1),
    type: AssetType.IMAGE
  }
];

const CHOSEN_SUMMER_CONFERENCE_GALLERY_AR: Asset[] = [
  {
    id: 5,
    name: "فيض مؤتمر الصيف",
    url: mediaService.getMediaUrl(EntityType.EVENT, "chosen-summer-conference", AssetType.IMAGE, Extension.PNG, 1),
    type: AssetType.IMAGE
  }
];

const MONTHLY_WORSHIP_ENCOUNTER_GALLERY_EN: Asset[] = [
  {
    id: 6,
    name: "Monthly Worship Encounter",
    url: mediaService.getMediaUrl(EntityType.EVENT, "monthly-worship-encounter", AssetType.IMAGE, Extension.PNG, 1),
    type: AssetType.IMAGE
  },
  {
    id: 7,
    name: "Intercession Moment",
    url: mediaService.getMediaUrl(EntityType.EVENT, "monthly-worship-encounter", AssetType.IMAGE, Extension.PNG, 2),
    type: AssetType.IMAGE
  },
  {
    id: 7,
    name: "Intercession Moment",
    url: mediaService.getMediaUrl(EntityType.EVENT, "monthly-worship-encounter", AssetType.IMAGE, Extension.PNG, 3),
    type: AssetType.IMAGE
  }
];

const MONTHLY_WORSHIP_ENCOUNTER_GALLERY_AR: Asset[] = [
  {
    id: 6,
    name: "Monthly Worship Encounter",
    url: mediaService.getMediaUrl(EntityType.EVENT, "monthly-worship-encounter", AssetType.IMAGE, Extension.PNG, 1),
    type: AssetType.IMAGE
  },
  {
    id: 7,
    name: "Intercession Moment",
    url: mediaService.getMediaUrl(EntityType.EVENT, "monthly-worship-encounter", AssetType.IMAGE, Extension.PNG, 2),
    type: AssetType.IMAGE
  },
  {
    id: 7,
    name: "Intercession Moment",
    url: mediaService.getMediaUrl(EntityType.EVENT, "monthly-worship-encounter", AssetType.IMAGE, Extension.PNG, 3),
    type: AssetType.IMAGE
  }
];

export const CHOSEN_SPORTS_DAY_MEDIA_EN: Media = {
  logo: {
    id: 101,
    name: "Chosen Sports Day Logo",
    url: "logos/events/chosen-sports-day-en.svg",
    type: AssetType.LOGO
  },
  cover: {
    id: 102,
    name: "Chosen Sports Day Cover",
    url: "logos/events/chosen-sports-day-en.svg",
    type: AssetType.COVER
  },
  videos: [],
  photos: CHOSEN_SPORTS_DAY_GALLERY_EN,
  files: []
};

export const CHOSEN_SPORTS_DAY_MEDIA_AR: Media = {
  logo: {
    id: 101,
    name: "شعار يوم الرياضة - تشوزين",
    url: "logos/events/chosen-sports-day-ar.svg",
    type: AssetType.LOGO
  },
  cover: {
    id: 102,
    name: "غلاف يوم الرياضة - تشوزين",
    url: "logos/events/chosen-sports-day-ar.svg",
    type: AssetType.COVER
  },
  videos: [],
  photos: CHOSEN_SPORTS_DAY_GALLERY_AR,
  files: []
};

export const CHOSEN_WINTER_CONFERENCE_MEDIA_EN: Media = {
  logo: {
    id: 201,
    name: "Chosen Winter Conference Logo",
    url: "logos/events/chosen-winter-conference-en.svg",
    type: AssetType.LOGO
  },
  cover: {
    id: 202,
    name: "Chosen Winter Conference Cover",
    url: "logos/events/chosen-winter-conference-en.svg",
    type: AssetType.COVER
  },
  videos: [],
  photos: CHOSEN_WINTER_CONFERENCE_GALLERY_EN,
  files: []
};

export const CHOSEN_WINTER_CONFERENCE_MEDIA_AR: Media = {
  logo: {
    id: 201,
    name: "شعار مؤتمر الشتاء - تشوزين",
    url: "logos/events/chosen-winter-conference-ar.svg",
    type: AssetType.LOGO
  },
  cover: {
    id: 202,
    name: "غلاف مؤتمر الشتاء - تشوزين",
    url: "logos/events/chosen-winter-conference-ar.svg",
    type: AssetType.COVER
  },
  videos: [],
  photos: CHOSEN_WINTER_CONFERENCE_GALLERY_AR,
  files: []
};

export const CHOSEN_SUMMER_CONFERENCE_MEDIA_EN: Media = {
  logo: {
    id: 301,
    name: "Chosen Summer Conference Logo",
    url: "logos/events/chosen-summer-conference-en.svg",
    type: AssetType.LOGO
  },
  cover: {
    id: 302,
    name: "Chosen Summer Conference Cover",
    url: "logos/events/chosen-summer-conference-en.svg",
    type: AssetType.COVER
  },
  videos: [],
  photos: CHOSEN_SUMMER_CONFERENCE_GALLERY_EN,
  files: []
};

export const CHOSEN_SUMMER_CONFERENCE_MEDIA_AR: Media = {
  logo: {
    id: 301,
    name: "شعار مؤتمر الصيف - تشوزين",
    url: "logos/events/chosen-summer-conference-ar.svg",
    type: AssetType.LOGO
  },
  cover: {
    id: 302,
    name: "غلاف مؤتمر الصيف - تشوزين",
    url: "logos/events/chosen-summer-conference-ar.svg",
    type: AssetType.COVER
  },
  videos: [],
  photos: CHOSEN_SUMMER_CONFERENCE_GALLERY_AR,
  files: []
};

export const MONTHLY_WORSHIP_ENCOUNTER_MEDIA_EN: Media = {
  logo: {
    id: 401,
    name: "Monthly Worship Encounter Logo",
    url: "logos/events/monthly-worship-encounter-en.svg",
    type: AssetType.LOGO
  },
  cover: {
    id: 402,
    name: "Monthly Worship Encounter Cover",
    url: "logos/events/monthly-worship-encounter-en.svg",
    type: AssetType.COVER
  },
  videos: [],
  photos: MONTHLY_WORSHIP_ENCOUNTER_GALLERY_EN,
  files: []
};

export const MONTHLY_WORSHIP_ENCOUNTER_MEDIA_AR: Media = {
  logo: {
    id: 401,
    name: "شعار لقاء العبادة الشهري",
    url: "logos/events/monthly-worship-encounter-ar.svg.svg",
    type: AssetType.LOGO
  },
  cover: {
    id: 402,
    name: "غلاف لقاء العبادة الشهري",
    url: "logos/events/monthly-worship-encounter-ar.svg.svg",
    type: AssetType.COVER
  },
  videos: [],
  photos: MONTHLY_WORSHIP_ENCOUNTER_GALLERY_AR,
  files: []
};